import React from 'react';

const SortSelectorVerticalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.83301 12.4997L9.99967 16.6663L14.1663 12.4997M5.83301 7.49967L9.99967 3.33301L14.1663 7.49967"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SortSelectorVerticalIcon;
